import { render, staticRenderFns } from "./LeftRightContent.vue?vue&type=template&id=5f424574&scoped=true&"
import script from "./LeftRightContent.vue?vue&type=script&lang=js&"
export * from "./LeftRightContent.vue?vue&type=script&lang=js&"
import style0 from "./LeftRightContent.vue?vue&type=style&index=0&id=5f424574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f424574",
  null
  
)

export default component.exports